/**
 * To manage states using Redux instead of Zustand,
   uncomment commented codes, then comment Zustand codes
 */

import logo from "../../assets/images/Logo.svg";
import hamburgerMenu from "../../assets/images/hamburgerMenu.svg";
import SearchForm from "./SearchForm";
import AccountWidget from "./AccountWidget";
// import { toggleMenu } from "../../features/uiSlice";
// import { useDispatch, useSelector } from "react-redux";
import useStore from "../../store";
import { NavLink } from "react-router-dom";

const Header = () => {
  // const dispatch = useDispatch();
  // const menuOpen = useSelector((state) => state.ui.menuOpen);
  const { menuOpen, setMenuOpen } = useStore();

  return (
    <header className="fixed z-50 top-0 left-0 h-[77px] w-full bg-black-100 border-b border-[#2B4657] flex items-center">
      <div className="flex pl-[35px] md:pl-10 lg:w-[339px]">
        <button
          className="lg:hidden"
          onClick={() => {
            setMenuOpen(!menuOpen);
            // dispatch(toggleMenu(!menuOpen));
          }}
        >
          <img src={hamburgerMenu} className="" alt="hamburger icon" />
        </button>
        <NavLink to={"/dashboard"}>
          <img
            src={logo}
            className="hidden min-w-[135px] w-[135px] lg:block"
            alt="Logo"
          />
        </NavLink>
      </div>
      <div className="flex-1 flex items-center justify-end gap-x-5 pr-[35px] md:justify-between md:pl-8 md:pr-10">
        <div className="flex-1 max-w-[792px] hidden md:block">
          <SearchForm />
        </div>
        <AccountWidget />
      </div>
    </header>
  );
};

export default Header;
